'use strict';
var ProductDetailController = /** @class */ (function () {
    /*@ngInject*/
    function ProductDetailController(Auth, $scope, $rootScope, $window, $sce, UserService, CartService, ProductService, productId, itemCode, googleAnalytic, $mdDialog, $location, CommonDataService, productAlternatives, configurationService) {
        var _this = this;
        this.addToCart = function (itemCode, quantity, form) {
            var _this = this;
            this.ga.sendEvent('Customer', 'Quick view usage', 'Add to cart', 1);
            if (!quantity) {
                return false;
            }
            if (form[itemCode].$valid || (!this.itemDetail.isDiscontinued && !form[itemCode].$valid)) {
                this.cart.addItemQuantity(itemCode, quantity)
                    .then(function () {
                    _this.$mdDialog.hide();
                });
            }
        };
        this.viewSimilarProducts = function () {
            this.ga.sendEvent('Customer', 'Quick view usage', 'View Similar Product', 1);
            this.productService.gotoAlternateProduct = true;
            this.$location.path('/products/detail/' + self.products.attributeNamePath + '/' + self.products.productNamePath + '/' + self.products.productId + '/' + self.products.items[$scope.selectItemNum].itemCode);
        };
        this.closePopup = function () {
            this.$mdDialog.hide(true);
        };
        this.warningMessage = {
            heatSensitive: {
                icon: '../../assets/images/icons/thermo-icon.png',
                content: 'Heat sensitive item, may affect shipping method.'
            },
            tempHeatSensitive: {
                icon: '../../assets/images/icons/thermo-icon.png',
                content: 'Heat sensitive due to season. Overnight shipping is recommended.'
            },
            shortShelfLife: {
                icon: '../../assets/images/icons/icon_shelf-life.png',
                content: 'Please note: Item has a short shelf life of 6 months or less.'
            },
            prop65_CA: {
                icon: '../../assets/images/attention.png',
                content: 'This item can only be shipped to California.',
            },
            prop65_NonCA: {
                icon: '../../assets/images/attention.png',
                content: 'This item cannot be shipped to California.'
            }
        };
        this.inventories = {};
        this.products = {};
        this.itemDetail = {};
        this.sortOption = null;
        this.sortListVisible = false;
        this.isSortPlaceholder = true;
        this.sortSelected = "";
        this.sortProperty = "";
        this.select = function (item) {
            this.isSortPlaceholder = false;
            this.sortSelected = item;
            this.sortListVisible = false;
            this.display = item;
        };
        this.isSelected = function (item) {
            return item[this.sortProperty] === this.sortSelected[this.sortProperty];
        };
        this.sortShow = function () {
            console.log('show');
            this.sortListVisible = true;
        };
        this.oldPurchaseQuantity = 1;
        // this.isAdmin = Auth.isAdminSync;
        // this.Auth = Auth;
        var self = this;
        this.cart = CartService;
        this.Auth = Auth;
        this.productService = ProductService;
        this.ga = googleAnalytic;
        this.$mdDialog = $mdDialog;
        this.CommonDataService = CommonDataService;
        this.productAlternatives = productAlternatives;
        this.$location = $location;
        this.$rootScope = $rootScope;
        this.configurationService = configurationService;
        this.registrationServiceUrl = this.configurationService.getEnvironmentConfiguration().registrationServiceUrl;
        this.purchaseNumber = 1;
        this.loadedData = {
            item: {
                productDetails: {
                    ingredients: null
                }
            }
        };
        $rootScope.$on('$stateChangeStart', function () {
            _this.$mdDialog.hide();
        });
        //TODO: pass in real product id
        var productRequest = this.productService.getProductDetails(productId);
        var isTemporaryHeatSensitiveItem = function () {
            var dateNow = new Date();
            var from_date = Date.parse(new Date(dateNow.getFullYear(), 3, 1)); // the month is 0-based
            var to_date = Date.parse(new Date(dateNow.getFullYear(), 8, 30)); // the month is 0-based
            var today = Date.parse(dateNow);
            if (today > from_date && today < to_date) {
                return true;
            }
            else {
                return false;
            }
        };
        $scope.isTemporaryHeatSensitiveItem = isTemporaryHeatSensitiveItem();
        self.isLoggedIn = function () {
            var loggedInUser = this.Auth.getLoggedInUser();
            if (loggedInUser) {
                return true;
            }
            return false;
        };
        self.updateInventory = function (item) {
            $scope.totalStock = 0;
            var inventory = {};
            if (item && item.inventory) {
                var stocks_1 = [];
                var vendorBackOrder_1 = true;
                item.inventory.forEach(function (arr) {
                    $scope.totalStock += arr.stock;
                    stocks_1.push(arr.stock);
                    vendorBackOrder_1 = vendorBackOrder_1 && arr.vendorBackOrder;
                    if (arr.isDefault) {
                        inventory = arr;
                        inventory.stock = arr.stock > 0 ? arr.stock : 0;
                    }
                });
                inventory.vendorBackOrder = vendorBackOrder_1;
            }
            this.maxQty = inventory.stock;
            return inventory;
        };
        $scope.error = false;
        $scope.showProduct = false;
        $scope.$watch('vm.products', function (newVal, oldVal) {
            if (Object.keys(self.products).length && self.products.items.length > 1) {
                var obj = self.products;
                self.products = self.CommonDataService.filterProp65Items(obj);
            }
        });
        productRequest
            .then(function (productModel) {
            _this.CommonDataService.addAttributeProductPathsForSingleItem(productModel);
            self.products = productModel;
            self.checkOutOfStockProduct(productModel.items);
            self.calculateHasAlternatives(self.products);
            if (productModel.items.length == 1) {
                self.itemDetail = productModel.items[0];
            }
            else {
                for (var i = 0; i < productModel.items.length; i++) {
                    if (productModel.items[i].itemCode == itemCode) {
                        $scope.selectedItemNum = i;
                        self.itemDetail = productModel.items[i];
                        break;
                    }
                }
            }
            self.updateServingSizeInformation(self.itemDetail);
            // EK-2359
            if (self.itemDetail.hasOwnProperty('retailPrice') && !self.itemDetail.retailPrice && $rootScope.shouldRedirectToLogin === true) {
                self.Auth.logoutUnauthorizedUser();
            }
            $scope.labelText = $sce.trustAsHtml(self.products.labelText);
            self.inventories = self.updateInventory(self.itemDetail);
            self.loadedData.item = self.itemDetail;
            self.loadedData.item.productDetails = productModel;
            self.loadedData.item.defaultInventory = self.inventories;
            $scope.showProduct = true;
        })
            .catch(function (error) {
            $scope.error = true;
        })
            .finally(function () {
            // set the default tab to be displayed
            _this.selectedTab = 'supplement';
            $scope.showProduct = true;
        });
        self.calculateHasAlternatives = function (product) {
            product.hasAlternatives = false;
            if (!self.isLoggedIn())
                return;
            this.productAlternatives
                .getProductIdsWithAlternativesAsPromise([product.productId])
                .then(function (productIdSet) { return product.hasAlternatives = productIdSet.has(product.productId); }, function () { });
        };
        self.checkOutOfStockProduct = function (items) {
            items.forEach(function (item) {
                if (item.inventory.length) {
                    item.inventory.forEach(function (arr) {
                        if (arr.isDefault) {
                            $scope.stock = arr.stock;
                            var date = new Date();
                            var currentDate = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + 'T' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
                            if (arr.expectedDeliverDate == null) {
                                $scope.content = "This item is currently out of stock. We do not have an expected ship date for this item to be available to ship. Please contact Customer Support at 800.654.4432 for further details or email customer support.";
                            }
                            else if (arr.expectedDeliverDate < currentDate) {
                                $scope.expectedDeliverDate = arr.expectedDeliverDate;
                                $scope.content = "This item is currently out of stock. We do not have an expected ship date for this item to be available to ship. Please contact Customer Support at 800.654.4432 for further details or email customer support.";
                            }
                            else {
                                $scope.content = "Estimated Ship Date:" + arr.expectedDeliverDate.split('T')[0];
                                $scope.expectedDeliverDate = arr.expectedDeliverDate;
                            }
                        }
                    });
                }
                else {
                    $scope.stock = 0;
                    $scope.content = "This item is currently out of stock. We do not have an expected ship date for this item to be available to ship. Please contact Customer Support at 800.654.4432 for further details or email customer support.";
                }
            });
        };
        self.purchaseQuantityList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        if (self.itemDetail.minimumSaleQuantity > 1) {
            $scope.purchaseNumber = self.itemDetail.minimumSaleQuantity;
            self.purchaseQuantityList = [];
            for (var i = 1; i < 12; i++) {
                self.purchaseQuantityList.push(i * self.itemDetail.mandatorySalesMultiple);
            }
        }
        $scope.$watch('selectedItemNum', function (num) {
            if (self.products.hasOwnProperty('items')) {
                self.itemDetail = self.products.items[num];
            }
            self.updateServingSizeInformation(self.itemDetail);
            self.selectedImg = 'front';
            if (self.itemDetail.hasOwnProperty('inventory')) {
                $scope.totalStock = 0;
                self.inventories = self.updateInventory(self.itemDetail);
            }
            self.disableShoppingCart = function () {
                if (self.inventories.vendorBackOrder && self.inventories.stock <= 0) {
                    return true;
                }
                else if (self.itemDetail.isDiscontinued && self.inventories.stock <= 0) {
                    return true;
                }
                else if (self.itemDetail.isRestricted) {
                    return true;
                }
                else if (!self.itemDetail) { }
                else {
                    return false;
                }
            };
            self.disableCartBtn = function () {
                if (!self.purchaseNumber) {
                    return true;
                }
            };
        });
        $scope.viewSimilarProducts = function () {
            self.productService.gotoAlternateProduct = true;
            $location.path('/products/detail/' + self.products.attributeNamePath + '/' + self.products.productNamePath + '/' + self.products.productId + '/' + self.itemDetail.itemCode);
        };
        $scope.logIn = function () {
            $window.location = '/login';
        };
        $scope.signUp = function () {
            $window.location = $rootScope.singleRegistrationFlag ? self.registrationServiceUrl + 'emerson/register' : '/registration';
        };
        // var loggedInUser = this.Auth.getLoggedInUser();
        // console.log("log in",loggedInUser);
        UserService.get().then(function (user) {
            if (user.data.response !== undefined && user.data.response !== null)
                self.loggedInAs = user.data.response.accountType;
            self.loadedData.user = user.data.response;
        });
        /*quantity dropdown*/
        $scope.currentIndex = null;
        $scope.closeThis = closeThis;
        $scope.back_search = back_search;
        $scope.setCurrentItem = setCurrentItem;
        function closeThis() {
            $scope.currentIndex = null;
        }
        function back_search() {
            $window.history.back();
        }
        function setCurrentItem(itemId) {
            if (itemId == $scope.currentIndex) {
                $scope.currentIndex = null;
            }
            else {
                $scope.currentIndex = itemId;
            }
        }
        /*end quantity dropdown*/
    }
    ProductDetailController.prototype.isQuantityValid = function (form, currentItem) {
        var self = this;
        var currentProd = currentItem.itemCode;
        var currentProdQty = parseInt(form[currentProd].$viewValue);
        if (isNaN(currentProdQty)) {
            this.purchaseNumber = this.oldPurchaseQuantity;
        }
        else {
            this.oldPurchaseQuantity = currentProdQty;
        }
        if (currentItem.mandatorySalesMultiple != 0) {
            if (currentProdQty % currentItem.mandatorySalesMultiple !== 0) {
                self.multipleOf = true;
                document.getElementsByName(currentProd).forEach(function (item) {
                    if (item != undefined) {
                        var calcQty = Math.ceil(currentProdQty / currentItem.mandatorySalesMultiple) * currentItem.mandatorySalesMultiple;
                        item.value = calcQty;
                        form[currentProd].$viewValue = calcQty;
                    }
                });
            }
            else {
                self.multipleOf = false;
            }
        }
    };
    ProductDetailController.prototype.clearQuantity = function () {
        this.purchaseNumber = '';
    };
    ProductDetailController.prototype.updateServingSizeInformation = function (currentItem) {
        this.loadedData.item.servingSizeAmount = currentItem.servingSizeAmount;
        this.loadedData.item.servingsPerContainer = currentItem.servingsPerContainer;
        this.loadedData.item.servingSizeUnitOfMeasureAbbreviation = currentItem.servingSizeUnitOfMeasureAbbreviation;
    };
    ;
    return ProductDetailController;
}());
export default ProductDetailController;
//# sourceMappingURL=quickView.controller.js.map